import { useStore } from "@stores";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useFirebaseNotification = () => {
  const navigate = useNavigate();
  const { authStore } = useStore();
  const userId = authStore.currentUserId;

  useEffect(() => {
    // Push poruke stižu samo registrovanom uređaju prijavljenog korisnika.
    if (!userId) return;

    let cancelled = false;
    let unsubscribe: (() => void) | undefined;

    (async () => {
      try {
        const [{ onMessage }, { messaging }] = await Promise.all([
          import("firebase/messaging"),
          import("../../firebase"),
        ]);
        if (cancelled) return;

        unsubscribe = onMessage(messaging, (payload) => {
          const link = payload.data?.link;

          const title = payload.notification?.title || "Rasporedi Me";
          const body = payload.notification?.body;

          if (!("Notification" in window) || Notification.permission !== "granted")
            return;

          const notification = new Notification(title, {
            body,
            icon: "/favicon-96.png",
          });

          if (link) {
            notification.onclick = () => {
              window.focus();
              try {
                const url = new URL(link);
                navigate(url.pathname + url.search);
              } catch {
                navigate(link);
              }
              notification.close();
            };
          }
        });
      } catch (err) {
        // Pretraživač bez podrške za FCM (npr. iOS Safari van PWA) — bez push-a.
        console.warn("Firebase messaging nije dostupan.", err);
      }
    })();

    return () => {
      cancelled = true;
      unsubscribe?.();
    };
  }, [navigate, userId]);
};
